<template>
  <div>
    <v-tooltip v-if="enabled" bottom :disabled="!disabled">
      <template v-slot:activator="{ on, attrs }">
        <div :class="[float, 'd-inline-block']" v-on="on">
          <slot
            name="action"
            :attrs="attrs"
            :disabled="disabled"
            :enabled="enabled"
          ></slot>
        </div>
      </template>
      <span>{{ feature.text }}</span>
    </v-tooltip>
    <slot
      v-if="!enabled"
      name="action"
      :attrs="false"
      :disabled="disabled"
      :enabled="enabled"
    ></slot>
  </div>
</template>

<script>
export default {
  props: {
    feature: {
      type: Object,
      default: Object,
    },
    disabled: {
      type: Boolean,
      default: Boolean,
    },
    enabled: {
      type: Boolean,
      default: Boolean,
    },
    floatDirection: {
      type: String,
      default: "left",
    },
  },
  data() {
    return {};
  },
  created() {},
  computed: {
    float() {
      return {
        [`float-${this.floatDirection}`]: ["left", "right"].includes(
          this.floatDirection
        ),
      };
    },
  },
  methods: {},
};
</script>

<style></style>
